import React from 'react';
import { formatCurrency } from '../../../../lib/helpers/formatters';
import { useAuth } from '../../../../commons/Auth';

const TotalTr = ({
  totals = {},
  route = '',
  activeRoute = false,
  truncateTotals = false,
}) => {
  const [{ newIsAdmin }] = useAuth();
  const {
    cashedTotals = 0,
    netTotals = 0,
    grossTotals = 0,
    adminShareTotals = 0,
    earnedAdminShareTotals = 0,
    billableAdminShareTotals = 0,
  } = totals;

  return (
    <tr
      className="summary-tr"
      onClick={() => {
        return activeRoute === true
          ? (window.location.href = `${
              window.location.href.split('?')[0]
            }/${route}`)
          : null;
      }}
    >
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && newIsAdmin && <td>-</td>}
      {!truncateTotals && newIsAdmin && <td>-</td>}

      {newIsAdmin && (
        <td className="txt-table-right">{formatCurrency(netTotals)}</td>
      )}
      {newIsAdmin && (
        <td className="txt-table-right">{formatCurrency(grossTotals)}</td>
      )}
      {newIsAdmin && (
        <td className="txt-table-right">{formatCurrency(cashedTotals)} </td>
      )}
      <td className="txt-table-right">{formatCurrency(adminShareTotals)}</td>
      <td className="txt-table-right">
        {formatCurrency(earnedAdminShareTotals)}
      </td>
      <td className="txt-table-right">
        {formatCurrency(billableAdminShareTotals)}{' '}
      </td>
      {!truncateTotals && newIsAdmin && <td>-</td>}
      {!truncateTotals && newIsAdmin && <td>-</td>}
    </tr>
  );
};

export default TotalTr;
